import script from "./promptVariablesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./promptVariablesList.vue?vue&type=script&lang=ts&setup=true"

import "./promptVariablesList.vue?vue&type=style&index=0&id=0f398dd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f398dd6"]])

export default __exports__